import { defineStore }                              from 'pinia'
import { computed, inject, ref, shallowRef, watch } from "vue";
import { useRoute, useRouter }                      from "vue-router";
import { useStorage }                               from "@vueuse/core";

let router;
let route;

export const useMainStore = defineStore('main', () =>
{

    let router   = useRouter();
    let route    = useRoute();
    let seenHome = ref( false );

    document.seenHome = seenHome;

    const availableLang = [ "en", "fr" ];
    const lang          = shallowRef( [] );
    lang.value          = inject( 'lang' );

    const copydeck = shallowRef([]);
    copydeck.value = inject('copydeck');

    const copydeckAudio = shallowRef([]);
    copydeckAudio.value = inject('copydeckAudio');

    const characters = ref([]);
    characters.value = inject('characters');

    const packs = ref([]);
    packs.value = inject('packs');

    const decors = ref([]);
    decors.value = inject('decors');

    const songs = ref([]);
    songs.value = inject('songs').sort(() => Math.random() - 0.5);

    let songIndex = ref(0);

    const reactions = shallowRef([]);
    reactions.value = inject('reactions');

    const intros = shallowRef([]);
    intros.value = inject('intros');

    const avatars = shallowRef([]);
    avatars.value = inject('avatars');

    //const character = ref({key: "octave", name: {fr: "Octave", en:"Octave"}, gender:"M"});
    const character = computed ( () =>
                                     currentUserAccount?.value?.character ?
                                     characters.value.find( c => c.key === currentUserAccount?.value?.character ?? '') ??
                                     {} : {});

    let score            = computed( () => currentUserIndex.value >= 0 ? accounts.value[ currentUserIndex.value ].score : 0 );
    let showModal        = ref( false );
    let modalYes         = ref( false );
    let modalNo          = ref( false );
    let currentlyPlaying = ref( null );

    let lastPage     = ref( "" );
    let creatingUser = ref( {
        name      : "",
        image     : "",
        score     : 0,
        decor     : "foret",
        character : "octave",
        pack      : "pack1",
        inventory : { decor : [ "foret" ], pack : [ "pack1" ], character : [ "octave" ] },
    } );



    let characters_OLD = [
        {
            'name'     : {fr: 'Octave', en: 'Octave'},
            'key'      : 'octave',
            'image'    : 'Octave.png',
            'cost'     : 0,
            'unlocked' : true,
            'active'   : true,
            'type'     : 'character',
        },
        {
            'name'  : {fr: 'Coda', en: 'Coda'},
            'key'   : 'coda',
            'image' : 'Coda.png',
            'cost'  : 3,
            'type'  : 'character',
        },
        {
            'name'  : {fr:'Mélodie', en: 'Melody'},
            'key'   : 'melodie',
            'image' : 'Melodie.png',
            'cost'  : 3,
            'type'  : 'character',
        },
        {
            'name'  : {fr:'Alto', en: 'Alto'},
            'key'   : 'alto',
            'image' : 'Alto.png',
            'cost'  : 3,
            'type'  : 'character',
        },
    ];
    let decors_OLD     = [
        {
            'name'     : 'Forêt',
            'key'      : 'foret',
            'image'    : 'foret.jpg',
            'cost'     : 0,
            'unlocked' : true,
            'active'   : true,
            'type'     : 'decor',
        },
        {
            'name'  : 'Jungle',
            'key'   : 'jungle',
            'image' : 'jungle.jpg',
            'cost'  : 3,
            'type'  : 'decor',
        },
        {
            'name'  : 'Montagne',
            'key'   : 'montagne',
            'image' : 'montagne.jpg',
            'cost'  : 3,
            'type'  : 'decor',
        },
        {
            'name'  : 'Désert',
            'key'   : 'desert',
            'image' : 'desert.jpg',
            'cost'  : 3,
            'type'  : 'decor',
        },
    ];

    let game2_data = [
        {
            'slug'  : "melodie",
            'name'  : "Mélodie l'otarie",
            'image' : 'Melodie.png',
            'title' : "La visualisation",
        },
        {
            'slug'  : "coda",
            'name'  : "Coda le caméléon",
            'image' : 'Coda.png',
            'title' : "La méditation",
        },
        {
            'slug'  : "octave",
            'name'  : "Octave l'écureuil",
            'image' : 'Octave.png',
            'title' : "Le yoga",
        },
        {
            'slug'  : "alto",
            'name'  : "Alto le lynx",
            'image' : 'Alto.png',
            'title' : "La respiration profonde",
        },
    ];

    let accounts = useStorage('accounts', []);

    document.addEventListener("save-accounts", (e) => {
        accounts.value = e.detail
    })

    watch (accounts, (val) =>
    {

        console.log("Account has changed")
        if (currentUserIndex.value >= accounts.value.length)
        {
            //window.location.refresh();
        }
    });

    let currentUserIndex = useStorage('currentUserIndex', -1);


    function setCurrentUserIndex (index)
    {
        currentUserIndex.value = index;
    }

    watch( currentUserIndex, ( val ) =>
    {

        if ( val < 0 || val < accounts.value.length )
        {
            //window.location.reload();
        }
    } );

    let lastChange = useStorage('lastChange', " ");

    let currentUser = computed( () => currentUserIndex.value >= 0 ? accounts.value[currentUserIndex.value] : null);



    let characterKey = computed( () => lastChange.value != "" && currentUserIndex.value >= 0 ? accounts.value[currentUserIndex.value].character : null);

    let rewards = [
        {
            'name'  : "Masque 1",
            'image' : 'rewards/mask-alto-calm.png',
        },
        {
            'name'  : "Masque 2",
            'image' : 'rewards/mask-alto-calm.png',
        },
        {
            'name'  : "Masque 3",
            'image' : 'rewards/mask-alto-calm.png',
        },
        {
            'name'  : "Masque 4",
            'image' : 'rewards/mask-alto-calm.png',
        },
        {
            'name'  : "Masque 5",
            'image' : 'rewards/mask-alto-calm.png',
        },
        {
            'name'  : "Masque 6",
            'image' : 'rewards/mask-alto-calm.png',
        },
        {
            'name'  : "Masque 7",
            'image' : 'rewards/mask-alto-calm.png',
        },
        {
            'name'  : "Masque 8",
            'image' : 'rewards/mask-alto-calm.png',
        },
    ];

    router.isReady ().then ( setLangFromRoute );

    const ready = ref(true); //if we need to load something, initialize at false and set to true when loading completed

    function addToScore ( amount )
    {
        if (currentUserIndex.value >= 0)
        {
            accounts.value[currentUserIndex.value].score += amount;
        }
    }

    function selectItemInAccount (item)
    {
        if (currentUserIndex.value >= 0)
        {
            accounts.value[currentUserIndex.value][item.type] = item.key;
        }
    }

    function isInInventory (item)
    {
        if (currentUserIndex.value >= 0)
        {
            let list = accounts.value[currentUserIndex.value].inventory[item.type];
            return list.includes(item.key)
        }

        return false;
    }

    function isSelected (item)
    {
        if (currentUserIndex.value >= 0)
        {
            let account = accounts.value[currentUserIndex.value];
            let value = account[item.type];

            return value == item.key;
        }
    }

    function isAvailable (item)
    {
        if (isInInventory(item))
        {
            return true;
        }

        if (currentUserIndex.value >= 0)
        {
            return accounts.value[currentUserIndex.value].score >= item.cost;
        }

        return false;
    }


    function addItemToInventory (item)
    {
        if (currentUserIndex.value >= 0)
        {
            accounts.value[currentUserIndex.value].inventory[item.type].push(item.key);
        }
    }
    function getCopydeckAudio( group, key)
    {
        let c = copydeckAudio.value.find( c => c.group === group && c.key === key);

        return c;
    }
    function changeLang ( strLang )
    {
        if (availableLang.includes(strLang))
        {
            lang.value = strLang;
        }
    }

    function setLangFromRoute ()
    {
        let routeLang = route.params.lang ?? "";

        if (["en","fr"].includes(routeLang))
        {
            changeLang(routeLang);
        }
    }

    function getPreviousPage () {
        const lastPath = router.options.history.state.back;
        return lastPath ? lastPath : '/';
    }

    // @todo: this should save to the cms
    function unlockItem(items, item)
    {
        if (score.value - item.cost >= 0)
        {
            addToScore(-item.cost);
            addItemToInventory(item);
            selectItemInAccount(item);
            //item.unlocked = true;
        }
    }

    function selectItem(items, item)
    {
        items.forEach( i => i.active = false);
        item.active = true;
    }

    function openModal(yesFunc, noFunc) {
        showModal.value = true;
        modalYes.value = yesFunc;
        modalNo.value = noFunc;
    }

    function closeModal() {
        showModal.value = false;
    }

    function getSong ()
    {
        let song = songs.value[songIndex.value];
        songIndex.value++;

        return song;
    }

    let currentUserAccount = computed(() => accounts?.value?.[ currentUserIndex.value ] ?? accounts?.value?.[0] ?? false);

    // if (currentUserAccount.value)
    // {
    //     let currentKey = currentUserAccount.value.character;
    //     character.value = characters.find( c => c.key === currentKey);
    // }
    // let currentUserAccount = ref(false);
    //
    // currentUserAccount.value = accounts?.value?.[ currentUserIndex ] ?? accounts?.value?.[0] ?? false;

    let profileModalOpen = ref( false );

    let profileModalMode = ref( '' );

    /***
     *  Assumes that for each profile image, there's a -small.png version
     * */
    let profileImages    = ref( [
        'profil-01.png',
        'profil-02.png',
        'profil-03.png',
        'profil-04.png',
        'profil-05.png',
        'profil-06.png',
        'profil-07.png',
        'profil-08.png',
        'profil-09.png',
        'profil-10.png',
        'profil-11.png',
        'profil-12.png',
        'profil-13.png',
        'profil-14.png',
        'profil-15.png',
        'profil-16.png',
        'profil-17.png',
        'profil-18.png',
        'profil-19.png',
        'profil-20.png',
        'profil-21.png',
    ] );




    return {
        lang,
        seenHome,
        copydeck,
        copydeckAudio,
        character,
        characterKey,
        lastChange,
        ready,
        router,
        route,
        score,
        showModal,
        songs,
        packs,
        characters,
        avatars,
        reactions,
        intros,
        decors,
        game2_data,
        accounts,
        rewards,
        lastPage,
        creatingUser,
        currentUserIndex,
        modalYes,
        modalNo,
        currentlyPlaying,
        profileModalOpen,
        profileModalMode,
        profileImages,
        currentUserAccount,


        addToScore,
        unlockItem,
        selectItem,
        openModal,
        closeModal,
        getPreviousPage,
        getCopydeckAudio,
        getSong,
        isInInventory,
        isSelected,
        isAvailable,
        setCurrentUserIndex



    };
})
